import React from 'react';
import { useProfileSubscribeBanner } from '../../../hooks/useProfileSubscribeBanner';
import Stack from '../../v2BaseComponents/Stack';
import { colors } from '../../../utils/theme';
import { useNestedNavigation } from '../../../utils/appNavigationNames';
import Text from '../../v2BaseComponents/Text';
import Button from '../../v2BaseComponents/Button';

export type ProfileSubscribeBannerOwnProps = {
    profileId: string;
};

export type ProfileSubscribeBannerProps = ProfileSubscribeBannerOwnProps;

const ProfileSubscribeBanner: React.FC<ProfileSubscribeBannerProps> = ({ profileId }) => {
    const { nestedAccountNavigation } = useNestedNavigation();
    const { shouldShow, messaging } = useProfileSubscribeBanner({ profileId });

    if (!shouldShow) return null;

    return (
        <Stack
            vertical
            align="flex-start"
            fullWidth
            padding={8}
            style={{ backgroundColor: colors['Background'], borderRadius: 8, paddingBottom: 0 }}
            testID="profile-subscribe-banner"
        >
            <Text variant="bold-body-1">{messaging.message}</Text>
            <Button
                variant="text"
                title={messaging.buttonText}
                onPress={() => nestedAccountNavigation('subscription', undefined)}
                icon="ChevronRight"
                testID="profile-subscribe-banner-subscribe-button"
            />
        </Stack>
    );
};

export default React.memo(ProfileSubscribeBanner);
